"use client";

import React from 'react';
import { Button } from '@/components/ui/Button';
import { cn } from '@/lib/utils';

interface LearningEntryPromptProps {
  onSave: () => void;
  onSkip: () => void;
  className?: string;
}

export function LearningEntryPrompt({ onSave, onSkip, className }: LearningEntryPromptProps) {
  return (
    <div className={cn('rounded-2xl border border-indigo-500/30 bg-indigo-500/10 p-4', className)}>
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <p className="text-sm font-medium text-indigo-900 dark:text-indigo-100">
            Save this as a learning example for this client?
          </p>
          <p className="text-xs text-indigo-800/80 dark:text-indigo-100/80">
            Capture before/after edits to improve future drafts.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" onClick={onSkip}>
            Skip
          </Button>
          <Button size="sm" onClick={onSave}>
            Save
          </Button>
        </div>
      </div>
    </div>
  );
}
